import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=0b535035"
import script from "./VehicleManagement.vue?vue&type=script&lang=js"
export * from "./VehicleManagement.vue?vue&type=script&lang=js"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=0b535035&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports